<template>
  <div class="simple-bx layout align-center pa-3">
    <input
      v-model="task.data.text"
      autofocus
      class="content"
      @keydown.enter.stop="createTask"
    ></input>
    <div class="info-text">
      Press Enter to Save Task.
    </div>
  </div>
</template>

<script>
	import {CREATE_NEW_TASK} from "../../config/constants";

	export default {
		name: "SimpleTaskCreationComponent",
		props: {
			initialTask: Object
		},
		data() {
			return {
				task: this.initialTask,
				backupText: null,
			}
		},
		methods: {
			async createTask() {
				this.$emit('task-create', this.task);
			}
		},
	}
</script>

<style scoped>
	.simple-bx {
		border-radius: 6px;
		border: solid 1px #e8e8e8;
		background-color: #f3f3f3;
		min-width: 350px;
		position: relative;

	}
	.simple-bx .content {
		font-family: 'Roboto', sans-serif;
		font-size: 14px;
		font-weight: normal;
		font-style: normal;
		font-stretch: normal;
		line-height: 1.29;
		letter-spacing: normal;
		color: #4a4a4a;
		width: 100%;
	}
	.info-text {
		width: 100%;
		font-size: 12px;
		font-weight: normal;
		font-style: normal;
		font-stretch: normal;
		line-height: 1.5;
		letter-spacing: normal;
		text-align: right;
		color: #b1b1b1;
	}
</style>